import {ariaGetControlledElement, ariaIs, ariaSet} from '@vo/js/utils/aria'

export default (function () {
    const productSeries = document.querySelectorAll('[data-module="product-series"]')

    if (!productSeries.length) return

    productSeries.forEach((series) => {
        const toggle = series.querySelector('[data-product-series-toggle]')
        if (!toggle) return
        const target = ariaGetControlledElement(toggle)

        toggle.addEventListener('click', () => {
            if (ariaIs('expanded', toggle)) {
                ariaSet('expanded', toggle, 'false')
                ariaSet('expanded', target, 'false')
            } else {
                ariaSet('expanded', toggle, 'true')
                ariaSet('expanded', target, 'true')
            }
        })

        document.addEventListener('click', (event) => {
            const isClickInside = series.contains(event.target)

            if (!isClickInside && ariaIs('expanded', toggle)) {
                ariaSet('expanded', toggle, 'false')
                ariaSet('expanded', target, 'false')
            }
        })
    })
})
